import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import CircularProgress from '@mui/material/CircularProgress';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import GestureIcon from '@mui/icons-material/Gesture';
import type { MediaDocType } from '@ast-data/shared';
import { useMediaThumbUrl } from './useMediaBlobUrl';

/**
 * A picture as a small cropped preview, marked as a sketch where it is one —
 * for the layout dialogs, which show many pictures at once and need none of a
 * gallery card's fields.
 */
export default function MediaThumbnail({
    media,
    height
}: {
    media: MediaDocType;
    height: number;
}) {
    const { url, loading } = useMediaThumbUrl(media.id, media.updatedAt);
    return (
        <Box sx={{ position: 'relative' }}>
            {url ? (
                <CardMedia
                    component="img"
                    image={url}
                    alt={media.caption || media.originalName}
                    sx={{ height, objectFit: 'cover' }}
                />
            ) : (
                <Box
                    sx={{
                        height,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'action.hover'
                    }}
                >
                    {loading ? (
                        <CircularProgress size={24} />
                    ) : (
                        <BrokenImageIcon color="disabled" />
                    )}
                </Box>
            )}
            {media.kind === 'sketch' && (
                <GestureIcon
                    fontSize="small"
                    sx={{
                        position: 'absolute',
                        top: 4,
                        left: 4,
                        color: 'common.white',
                        filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.6))'
                    }}
                />
            )}
        </Box>
    );
}
